// extracted by mini-css-extract-plugin
module.exports = {"container":"EducationGoal_container__2_4NF","title":"EducationGoal_title__vOdp9","content":"EducationGoal_content__gi7Br"};